/**
 * @generated SignedSource<<96099cf96e7b0fafc15ab769c89dc135>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useNavSettingsService$data = {
  readonly properties: {
    readonly nodes: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly sidebar: {
    readonly nodes: ReadonlyArray<{
      readonly menuId: string | null | undefined;
      readonly visible: boolean | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useNavSettingsService";
};
export type useNavSettingsService$key = {
  readonly " $data"?: useNavSettingsService$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useNavSettingsService",
  "selections": [
    {
      "concreteType": "SettingsMenuItemConnection",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "menuId"
            },
            {
              "kind": "ScalarField",
              "name": "visible"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SettingsDisplayPropertyConnection",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsDisplayProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ],
  "type": "SettingsNavigationCustomisation"
};

(node as any).hash = "559a20c34fab36365d6ca9ab5d0c4645";

export default node;
